import moment from "moment";
import momentTz from "moment-timezone";

export function* range(start, end) {
  for (let i = start; i <= end; i++) {
    yield i;
  }
}

export const average = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;

export const timeDistance = (date1, date2) => {
  let distance = Math.abs(date1 - date2);
  const hours = Math.floor(distance / 3600000);
  distance -= hours * 3600000;
  const minutes = Math.floor(distance / 60000);
  distance -= minutes * 60000;
  const seconds = Math.floor(distance / 1000);
  return `${hours}:${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`;
};

export const calculateDuration = (fromTime, toTime) => {
  const duration = moment(toTime).diff(fromTime, "minutes");
  if (duration > 59) {
    if (duration % 60 > 0) {
      return `${duration / 60}hr ${duration % 60}min`;
    }
    return `${duration / 60}hr`;
  }
  return `${duration} min`;
};

//#region minutes to " hr min" format
/**
 * @description given minutes converts them to "hr min" format
 * @param {Number} minutes
 * @returns String
 */
export const formatDuration = (minutes) => {
  try {
    if (minutes === parseInt(0)) {
      return 0;
    }

    const time = parseInt(minutes);
    const hours = Math.floor(time / 60);
    const leftOverMinutes = minutes % 60;
    let format = "";
    if (hours) {
      format += hours + " hr ";
    }
    if (leftOverMinutes) {
      format += leftOverMinutes + " min";
    }
    if (format === "") {
      return "none";
    }
    return format;
  } catch (err) {
    console.error("Error in Stubs . formatDuration :- ", err);
  }
};
//#endregion

// #region get Duration
export const getDuration = (from, to) => {
  return moment.duration(moment(to).diff(moment(from))).asMinutes();
};
// #endregion

// #region truncated Task name
export const turnacatedTaskName = (taskName, projectName, clientName) => {
  const totalLength =
    taskName.length + projectName.length + clientName.length + 9;
  let turnacatedProjectName = projectName + "  ";
  let turnacatedClientName = clientName;
  let turnacatedTaskName = taskName + "  ";
  if (totalLength > 200 && projectName.length > 16) {
    turnacatedProjectName = projectName.slice(0, 16) + "..  ";
  }
  if (totalLength > 200 && clientName.length > 16) {
    turnacatedClientName = clientName.slice(0, 16) + "..";
  }
  if (taskName.length > 200) {
    turnacatedTaskName =
      taskName.slice(
        0,
        200 - (turnacatedClientName.length + turnacatedProjectName.length)
      ) + "..  ";
  }
  // return turnacatedTaskName + turnacatedProjectName + turnacatedClientName;
  return (
    <>
      <span>{turnacatedTaskName}</span>
      <span>{" > "}</span>
      <span style={{ color: "#0057e7" }}>{turnacatedProjectName}</span>
      <span>{" > "}</span>
      <span style={{ color: "#008744" }}>{turnacatedClientName}</span>
    </>
  );
};
// #endregion

// #region isToday
export const isToday = (date) => {
  const today = moment().toISOString();
  return moment(today).isSame(date, "day");
};
// #endregion
// #region Get WorkSlot Activity Percentage
export const getWorkSlotActivityPercentage = (workslot) => {
  const activityTotalDuration = workslot.activities.reduce(
    (total, activity) => {
      return total + getDuration(activity.startedAt, activity.endedAt);
    },
    0
  );

  const todayDuration = getDuration(workslot.slotFrom, workslot.slotTo);

  if (activityTotalDuration === 0 || todayDuration === 0) {
    return 0;
  }

  let activityPercentage = Math.ceil(
    (activityTotalDuration / todayDuration) * 100
  );
  if (activityPercentage > 95) {
    activityPercentage = 95;
  }
  return activityPercentage;
};
// #endregion

// #region Get Today Activity Percentage
export const getTodayActivityPercentage = (workslots) => {
  if (workslots.length === 0) {
    return 0;
  }

  const slotWisePercentage = workslots
    .filter((workSlotItem) => workSlotItem.slotType === "tracker")
    .map((workSlotItem) => {
      // Slot Duration
      const slotDuration = getDuration(
        workSlotItem.slotFrom,
        workSlotItem.slotTo
      );
      // Activity Duration
      const activityDuration = workSlotItem.activities.reduce(
        (acc, activityItem) => {
          return (
            acc + getDuration(activityItem.startedAt, activityItem.endedAt)
          );
        },
        0
      );

      if (activityDuration === 0 || slotDuration === 0) {
        return 0;
      }

      return activityDuration / slotDuration;
    });
  let activityPercentage = Math.ceil(average(slotWisePercentage) * 100)
  if (activityPercentage > 95) {
    activityPercentage = 95;
  }
  return activityPercentage
};
// #endregion

// #region Compare two array and return the difference
export const getDifferenceBetweenArrays = (
  oldArray,
  newArray,
  uniqueIdentifier
) => {
  console.log(oldArray, newArray, uniqueIdentifier, "adfasdfasdf");
  const addedData = [];
  const removedData = [];
  newArray.forEach((newData) => {
    const contains = oldArray.find(
      (e) => e[uniqueIdentifier] === newData[uniqueIdentifier]
    );
    console.log(contains, "newArray");
    if (!contains) {
      addedData.push(newData);
    }
  });
  oldArray.forEach((oldData) => {
    const contains = newArray.find(
      (e) => e[uniqueIdentifier] === oldData[uniqueIdentifier]
    );
    console.log(contains, "oldArray");

    if (!contains) {
      removedData.push(oldData);
    }
  });
  console.log(addedData, removedData);
  return [removedData, addedData];
};
// #endregion

/**
 * @description convert date from ONE timezone to ANOTHER
 * @param {Date} time
 * @param {String} timezone
 * @param {String} format
 */
export const changeTimzone = (
  time,
  timezone,
  format = "YYYY-MM-DD hh:mm:a"
) => {
  const timezoneObj = momentTz(momentTz(time), format).tz(timezone);
  return timezoneObj;
};


export const getDateStringFromTimestamp = (timestamp, timezone = null) => {
  let date;
  
  if (timezone) {
    // Use timezone-aware formatting
    const momentObj = momentTz(timestamp).tz(timezone);
    const year = momentObj.format('YYYY');
    const month = momentObj.format('MM');
    const dayOfMonth = momentObj.format('DD');
    
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const day = daysOfWeek[momentObj.day()]; // 0-6
    const monthIndex = momentObj.month(); // 0-11
    
    const formattedDate = `${day}, ${dayOfMonth} ${months[monthIndex]} ${year}`;
    return formattedDate;
  } else {
    // Fallback to original behavior for backward compatibility
    date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const dayOfMonth = String(date.getDate()).padStart(2, '0');

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = daysOfWeek[date.getDay()];

    const formattedDate = `${day}, ${dayOfMonth} ${months[date.getMonth()]} ${year}`;
    return formattedDate;
  }
};

export const getTimestampFromDateTime = (dateString, timeString, timezone) => {
  if (timezone) {
    // Create moment object in the specified timezone
    const dateTimeString = `${dateString} ${timeString}`;
    const momentObj = momentTz.tz(dateTimeString, "YYYY-MM-DD HH:mm", timezone);
    return momentObj.toISOString();
  } else {
    // Default behavior for backward compatibility
    const dateTimeString = `${dateString}T${timeString}:00.000Z`;
    return dateTimeString;
  }
}

export const calculateDateRange = (timeDuration, timezone) => {
  // If timezone is provided, use it; otherwise fall back to local time
  const currentDate = timezone 
    ? momentTz.tz(timezone).startOf('day')
    : moment().startOf('day');

  switch (timeDuration) {
    case "this week":
      const thisMonday = currentDate.clone().startOf('week').add(1, 'day'); // Monday
      const thisSunday = thisMonday.clone().add(6, 'days'); // Sunday
      return {
        from: thisMonday.toDate(),
        to: thisSunday.toDate(),
      };
    case "last week":
      const lastMonday = currentDate.clone().startOf('week').add(1, 'day').subtract(1, 'week');
      const lastSunday = lastMonday.clone().add(6, 'days');
      return {
        from: lastMonday.toDate(),
        to: lastSunday.toDate(),
      };
    case "next week":
      const nextMonday = currentDate.clone().startOf('week').add(1, 'day').add(1, 'week');
      const nextSunday = nextMonday.clone().add(6, 'days');
      return {
        from: nextMonday.toDate(),
        to: nextSunday.toDate(),
      };
    case "this month":
      const thisMonthStart = currentDate.clone().startOf('month');
      const thisMonthEnd = currentDate.clone().endOf('month');
      return {
        from: thisMonthStart.toDate(),
        to: thisMonthEnd.toDate(),
      };
    case "last month":
      const lastMonthStart = currentDate.clone().subtract(1, 'month').startOf('month');
      const lastMonthEnd = currentDate.clone().subtract(1, 'month').endOf('month');
      return {
        from: lastMonthStart.toDate(),
        to: lastMonthEnd.toDate(),
      };
    case "yesterday":
      const yesterday = currentDate.clone().subtract(1, 'day');
      return {
        from: yesterday.toDate(),
        to: yesterday.toDate(),
      };
    case "today":
      return {
        from: currentDate.toDate(),
        to: currentDate.toDate(),
      };
    default:
      return "Invalid time duration";
  }
}